import { render, staticRenderFns } from "./claim-list-component.vue?vue&type=template&id=2549e103&"
import script from "./claim-list-component.vue?vue&type=script&lang=ts&"
export * from "./claim-list-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports